import React from "react";
import {Box, Typography} from "@mui/material";
import parkourLogo from "../assets/ParkourLogo.svg";

// Shared chrome for the authentication screens: the brand mark, a heading, and a single column.
// Sign in and Forgot password both sit inside it so they cannot drift apart visually.
//
// Sized for the dialog that hosts it (AuthDialog), not for a page of its own -- the portal's title
// bar and the address bar already say which site this is, so there is no footer domain line here.

export const BLUE = "#1498D8";
export const HEADING = "#2B2B2B";
export const MUTED = "#717171";
export const BORDER = "#E0E0E0";
export const DANGER = "#D64535";

export default function AuthShell({title, subtitle, children}: {title: string; subtitle?: string; children: React.ReactNode}) {
    return (
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", boxSizing: "border-box"}}>
            <Box component="img" src={parkourLogo} alt="ParkourAI"
                 sx={{width: 64, height: 64, objectFit: "contain", mb: 1.5}}/>

            <Typography component="h2" sx={{fontSize: 24, fontWeight: 500, color: HEADING, mb: subtitle ? 0.5 : 3}}>
                {title}
            </Typography>

            {subtitle && (
                <Typography sx={{fontSize: 14, color: MUTED, mb: 3, maxWidth: 420, textAlign: "center"}}>
                    {subtitle}
                </Typography>
            )}

            <Box sx={{width: "100%", display: "flex", flexDirection: "column", gap: 2}}>
                {children}
            </Box>
        </Box>
    );
}

export function ErrorText({children}: {children: React.ReactNode}) {
    return (
        <Typography role="alert" sx={{fontSize: 13, color: DANGER}}>
            {children}
        </Typography>
    );
}
